module.exports = __webpack_public_path__ + "static/media/logo_close_white.334fd3d2.svg";